import { useEffect } from 'react';
import { featureFlagClient } from '@trello/feature-flag-client';
import { workspaceNavigationEnabled } from './workspaceNavigationEnabled';
import { memberId } from '@trello/session-cookie';

const flagEnabled = featureFlagClient.get('teamplates.web.left-nav-bar', false);

export const useWorkspaceNavigationEnabled = () => {
  const isWorkspaceNavigationEnabled = !!memberId && flagEnabled;

  useEffect(() => {
    workspaceNavigationEnabled.setValue(isWorkspaceNavigationEnabled);
  }, [isWorkspaceNavigationEnabled]);

  return isWorkspaceNavigationEnabled;
};
